var map = {
	"./b026/nav/nav": [
		658,
		24
	],
	"./b027site/nav/nav": [
		662,
		20
	],
	"./b027sport/nav/nav": [
		666,
		16
	],
	"./bet365luck/nav/nav": [
		668,
		14
	],
	"./betl/nav/nav": [
		672,
		10
	],
	"./common/nav/nav": [
		676,
		6
	],
	"./taiyangcheng018/nav/nav": [
		678,
		4
	],
	"./veniceman/nav/nav": [
		682,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 652;


//////////////////
// WEBPACK FOOTER
// ./src/components/different lazy ^\.\/.*\/nav\/nav$
// module id = 652
// module chunks = 27